export default __webpack_public_path__ + "static/media/artesanias.be9b91b7.jpg";